import { render, staticRenderFns } from "./ChildFolder.vue?vue&type=template&id=61a84df0&scoped=true"
import script from "./ChildFolder.vue?vue&type=script&lang=js"
export * from "./ChildFolder.vue?vue&type=script&lang=js"
import style0 from "./ChildFolder.vue?vue&type=style&index=0&id=61a84df0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a84df0",
  null
  
)

export default component.exports